/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { find, merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@material-ui/core';
//
import { BaseOptionChart } from '../../charts';
import dashboardService from './DashboardService';
import TokenDecoder from '../../../helpers/TokenDecoder';
import _ from 'lodash';
import getDate from 'date-fns/getDate';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

export default function AppWebsiteVisits() {

  const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

  const [data, setData] = useState([]);

  let endDate = ((new Date(new Date().setDate(new Date().getDate() + 6))).toString()).substring(4, 10);
  let startDate = ((new Date()).toString()).substring(4, 10);

  let dateArray = [];
  for (let i = 0; i < 7; i++) {
    dateArray.push((new Date(new Date().setDate(new Date().getDate() + i)).toISOString().split('T')[0]));
  }

  let shortDateArray = [];
  for (let i = 0; i < 7; i++) {
    let date = (new Date(new Date().setDate(new Date().getDate() + i))).toString();
    shortDateArray.push(date.substring(4, 10));
  }

  let longDateArray = [...dateArray]
  longDateArray.forEach((element, index) => {
    let value = element.concat('T00:00:00')
    longDateArray.splice((index), 1, value);
  });

  async function GetForecastData() {
    const response = await dashboardService.GetProductForcastForDasboard(OpID);
    let res = _.cloneDeep(response);

    let newDataArray = [...res];
    newDataArray.forEach(x => {
      let quantity = [...x.quantity]

      let qdateArray = []
      let cropid = '';

      quantity.forEach(y => {
        cropid = y.cropID;
        qdateArray.push(y.date)
      })
      const newValues = longDateArray.filter(value => !qdateArray.includes(value));
      newValues.forEach(n => {
        const item = {
          cropID: cropid,
          productQuantity: 0,
          productName: x.productName,
          date: n,
          isActive: true,
        }
        x.quantity.push(item);
      })
    })


    newDataArray.forEach(d => {
      const sortedData = d.quantity.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
    })

    let arrays = [];
    res.forEach(x => {
      let arrays2 = [];
      x.quantity.forEach(y => {
        arrays2.push(
          y.productQuantity
        );
      });
      arrays.push({
        name: x.productName,
        data: arrays2
      })
    });
    setData(arrays);
  }

  useEffect(() => {
    trackPromise(GetForecastData());
  }, [])

  let productList = [];
  data.forEach(x => {
    productList.push(x.name)
  })

  let randomColorGenerator = function () {
    return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
  };

  let colorArray = []
  productList.forEach(element => {
    colorArray.push(randomColorGenerator())
  });

  const state = {
    series: data,
    options: {
      colors: colorArray,
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          },
          columnWidth: '45%'
        },
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      title: {
        text: ''
      },
      xaxis: {
        categories: [...shortDateArray],
        labels: {
          formatter: function (val) {
            return val
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    },
  };


  return (
    <>
      <LoadingComponent />
      <div id="chart">
        <Card style={{ justifycontent: 'center', padding: '1.5rem' }} >
          <h3>Product Forecast for Current week </h3>
          {/* <h5>(From {new Date().toISOString().slice(0, 10)} To {(new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0])}) </h5><br /> */}
          <h5>{startDate} to {endDate} </h5><br />
          <ReactApexChart options={state.options} series={state.series} type="bar" height={330} />
        </Card>
      </div>

    </>
  );
}





